import api from './api';

class AuthService {
    async login(credentials) {
        try {
            const response = await api.post('/auth/login', credentials);
            if (response.data.success) {
                const { token, refreshToken, user, tenant } = response.data.data;
                return { user, tenant, token, refreshToken };
            }
            throw new Error(response.data.error || 'Login failed');
        } catch (error) {
            console.error('Login API error:', error);
            throw error;
        }
    }

    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
        localStorage.removeItem('tenant');
    }

    getCurrentUser() {
        const user = localStorage.getItem('user');
        return user ? JSON.parse(user) : null;
    }

    getCurrentTenant() {
        const tenant = localStorage.getItem('tenant');
        return tenant ? JSON.parse(tenant) : null;
    }

    getToken() {
        return localStorage.getItem('token');
    }

    isAuthenticated() {
        return !!this.getToken();
    }

    // ============ MailCow Email Password Reset Methods ============

    /**
     * Step 1: Send password reset link via email (MailCow)
     */
    async forgotPassword(email, subdomain) {
        try {
            const response = await api.post('/auth/forgot-password-mailcow', { email, subdomain });
            return response.data;
        } catch (error) {
            console.error('Forgot password error:', error);
            throw error.response?.data || error;
        }
    }

    /**
     * Step 2: Validate reset token
     */
    async validateResetToken(token) {
        try {
            const response = await api.get(`/auth/validate-reset-token/${token}`);
            return response.data;
        } catch (error) {
            console.error('Validate reset token error:', error);
            throw error.response?.data || error;
        }
    }

    /**
     * Step 3: Reset password with token
     */
    async resetPassword(token, password, confirmPassword) {
        try {
            const response = await api.post(`/auth/reset-password-mailcow/${token}`, {
                password,
                confirm_password: confirmPassword
            });
            return response.data;
        } catch (error) {
            console.error('Reset password error:', error);
            throw error.response?.data || error;
        }
    }

    // ============ OTP Password Reset Methods (legacy) ============

    /**
     * Step 1: Request OTP to be sent to phone
     */
    async forgotPasswordOTP(phone, subdomain) {
        try {
            const response = await api.post('/auth/forgot-password-otp', { phone, subdomain });
            return response.data;
        } catch (error) {
            console.error('Forgot password OTP error:', error);
            throw error.response?.data || error;
        }
    }

    /**
     * Step 2: Verify the OTP
     */
    async verifyResetOTP(otp, subdomain) {
        try {
            const response = await api.post('/auth/verify-reset-otp', { otp, subdomain });
            return response.data;
        } catch (error) {
            console.error('Verify reset OTP error:', error);
            throw error.response?.data || error;
        }
    }

    /**
     * Step 3: Reset password with verified OTP
     */
    async resetPasswordWithOTP(otp, newPassword, confirmPassword, subdomain) {
        try {
            const response = await api.post('/auth/reset-password-otp', {
                otp,
                new_password: newPassword,
                confirm_password: confirmPassword,
                subdomain
            });
            return response.data;
        } catch (error) {
            console.error('Reset password with OTP error:', error);
            throw error.response?.data || error;
        }
    }
}

export default new AuthService();
